import React from 'react';
import { motion } from 'framer-motion';
import { Check, Zap, Layers, MessageCircle } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-[#0a0f1e] overflow-hidden" data-id="element-140">
      <div className="container mx-auto px-4" data-id="element-141">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2" data-id="element-143">
            <div className="inline-block px-4 py-1 rounded-full bg-blue-500/10 text-blue-400 font-medium text-sm mb-6" data-id="element-144">
              LA SOLUCIÓN: MÉTODO VISUAL
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-145">
              El sistema{' '}
              <span className="text-[#25D366]" data-id="element-146">CHATBOT AGENDA TOTAL</span>
            </h2>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-147">
              Muchos intentan automatizar su WhatsApp y se rinden porque la
              tecnología parece complicada. Se pierden entre APIs, tokens y
              configuraciones.
            </p>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-148">
              Por eso hemos creado algo diferente. No es solo un texto aburrido.
              Es un sistema entregado en un formato visual optimizado para que
              lo configures mientras ves la pantalla.
            </p>

            <div className="space-y-6" data-id="element-149">
              {[{
              icon: Layers,
              title: 'Mapa de Arquitectura Técnica',
              desc: 'Conecta tu Calendario Real (Google/Outlook) con WhatsApp.'
            }, {
              icon: Zap,
              title: 'Activa el "Cerebro Digital"',
              desc: 'Usa Zapier/Make para que todo se mueva solo sin intervención.'
            }, {
              icon: MessageCircle,
              title: 'Guiones de Respuesta Obligatoria',
              desc: 'Hacen que el cliente confirme con un simple "1".'
            }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-150">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-[#25D366]/10 flex items-center justify-center" data-id="element-151">
                    <item.icon className="h-6 w-6 text-[#25D366]" data-id="element-152" />
                  </div>
                  <div data-id="element-153">
                    <h4 className="text-white font-bold text-lg" data-id="element-154">
                      {item.title}
                    </h4>
                    <p className="text-slate-400" data-id="element-155">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2 relative" data-id="element-156">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#25D366]/20 to-blue-600/20 blur-3xl rounded-full" data-id="element-157" />
            <div className="relative bg-[#0f1629] border border-slate-800 rounded-2xl p-8 shadow-2xl" data-id="element-158">
              <div className="flex items-center gap-4 mb-8 border-b border-slate-800 pb-4" data-id="element-159">
                <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-160" />
                <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-161" />
                <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-162" />
                <span className="text-slate-500 text-sm ml-2" data-id="element-163">
                  flow-builder.exe
                </span>
              </div>

              {/* Abstract representation of a flow builder */}
              <div className="space-y-4" data-id="element-164">
                <div className="flex justify-center" data-id="element-165">
                  <div className="bg-slate-800 text-slate-300 px-4 py-2 rounded-lg text-sm border border-slate-700" data-id="element-166">
                    Nueva Cita Agendada
                  </div>
                </div>
                <div className="h-8 w-0.5 bg-slate-700 mx-auto" data-id="element-167" />
                <div className="flex justify-center" data-id="element-168">
                  <div className="bg-[#25D366]/20 text-[#25D366] px-4 py-2 rounded-lg text-sm border border-[#25D366]/30 font-mono" data-id="element-169">
                    Enviar WhatsApp Confirmación
                  </div>
                </div>
                <div className="h-8 w-0.5 bg-slate-700 mx-auto" data-id="element-170" />
                <div className="grid grid-cols-2 gap-8 relative" data-id="element-171">
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-0.5 bg-slate-700" data-id="element-172" />
                  <div className="flex flex-col items-center" data-id="element-173">
                    <div className="h-4 w-0.5 bg-slate-700" data-id="element-174" />
                    <div className="bg-slate-800 text-slate-300 px-3 py-2 rounded-lg text-xs border border-slate-700" data-id="element-175">
                      Cliente Confirma
                    </div>
                  </div>
                  <div className="flex flex-col items-center" data-id="element-176">
                    <div className="h-4 w-0.5 bg-slate-700" data-id="element-177" />
                    <div className="bg-slate-800 text-slate-300 px-3 py-2 rounded-lg text-xs border border-slate-700" data-id="element-178">
                      No Responde
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-800 text-center" data-id="element-179">
                <p className="text-sm text-slate-400" data-id="element-180">
                  <span className="text-[#25D366] font-bold" data-id="element-181">Drag & Drop:</span>{' '}
                  Diseña tu flujo visualmente
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}